import { Modal } from "./Modal.js";

/** Shared registry prevents duplicate handlers across independent entry points. */
export class ModalManager {
    private static manager: ModalManager;
    private static registry = new WeakMap<HTMLElement, Modal>();
    private instances: Modal[] = [];

    private constructor() {}

    public static use(reset: boolean = false): ModalManager {
        if (!ModalManager.manager || reset) {
            ModalManager.manager = new ModalManager();
        }
        ModalManager.manager.instances = Array.from(
            document.querySelectorAll<HTMLElement>(
                '[scope="modal"][role="dialog"]',
            ),
            (element) => ModalManager.get(element),
        );
        return ModalManager.manager;
    }

    public static get(element: HTMLElement): Modal {
        let modal = this.registry.get(element);
        if (!modal) {
            modal = new Modal(element);
            this.registry.set(element, modal);
        }
        return modal;
    }

    public get length(): number {
        return this.instances.length;
    }
}
